export default __webpack_public_path__ + "static/media/burger.37e82535.svg";